import { TicketService } from './../../../../services/ticket/ticket.service';
import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-tk-all-notes',
  templateUrl: './tk-all-notes.component.html',
  styleUrls: ['./tk-all-notes.component.css']
})
export class TkAllNotesComponent implements OnInit,OnChanges {
  @Input() selectedTicket: any;
  notesList: any[];

  constructor(private ticketSrv: TicketService) { }

  ngOnInit() {
    this.getNotes();
  }
  ngOnChanges(changes){
    if (changes.firstChange)return;
    this.notesList = [];
    this.getNotes()
  }

  getNotes() {
    this.notesList = null
    const payload = { code: this.selectedTicket.code, type: 1 }
    this.ticketSrv.fetchTicketChatExtra(payload).subscribe((res: any[]) => {
      this.notesList = res
    })
  }
  getNameInitials(name: string) {
    const [fname, lname] = name.split(' ');
    return `${fname[0]}${lname[0]}`
  }

}
